<template>
  <section class="max-w-[1440px] mx-auto px-12 py-12 space-y-12">

    <!-- HEADER -->
    <header>
      <h2 class="text-4xl font-black tracking-tight">
        Brand Settings
      </h2>
      <p class="text-slate-400 mt-2 max-w-2xl">
        Manage your brand account, security preferences, and subscription details.
      </p>
    </header>

    <!-- MAIN GRID -->
    <section class="grid grid-cols-1 lg:grid-cols-12 gap-12">

      <!-- LEFT -->
      <div class="lg:col-span-8 space-y-8">

        <!-- Brand PROFILE -->
        <div class="bg-white p-8 rounded-[2.5rem] premium-shadow border border-slate-50">
          <h3 class="text-xl font-bold mb-6">
            Brand Profile
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="label">Brand Name</label>
              <input
                v-model="profile.name"
                class="input"
                placeholder="Your brand name"
              />
            </div>

            <div>
              <label class="label">Business Email</label>
              <input
                v-model="profile.email"
                class="input"
                disabled
              />
            </div>

            <div>
              <label class="label">Website</label>
              <input
                v-model="profile.website"
                class="input"
                placeholder="https://"
              />
            </div>

            <div>
              <label class="label">Industry Focus</label>
              <select v-model="profile.industry" class="input">
                <option value="">Select industry</option>
                <option>Technology</option>
                <option>Finance</option>
                <option>E-commerce</option>
                <option>Education</option>
                <option>Consumer Brands</option>
              </select>
            </div>
            <div>
               <button
                @click="save"
                class="bg-primary text-white px-12 py-4 rounded-xl
                      font-bold text-xs uppercase tracking-wider
                      hover:opacity-90 transition"
              >
                Save Settings
              </button>
            </div>
          </div>
          
        </div>

        <!-- DATA & PRIVACY -->
        <!-- <div class="bg-white p-8 rounded-[2.5rem] premium-shadow border border-slate-50">
          <h3 class="text-xl font-bold mb-6">
            Data & Privacy
          </h3>

          <div class="space-y-6">
            <div class="toggle-row">
              <div>
                <strong>Aggregated Data Access</strong>
                <p class="muted">
                  Allow access to anonymized audience intelligence dashboards
                </p>
              </div>
              <input type="checkbox" v-model="privacy.aggregated" />
            </div>

            <div class="toggle-row">
              <div>
                <strong>Insights Export</strong>
                <p class="muted">
                  Enable CSV / report exports (aggregated only)
                </p>
              </div>
              <input type="checkbox" v-model="privacy.export" />
            </div>
          </div>
        </div> -->

        <!-- SECURITY -->
        

      </div>

      <!-- RIGHT -->
      <div class="lg:col-span-4 space-y-8">

        <!-- PLAN -->
        <!-- <div class="bg-primary text-white p-8 rounded-[2rem] premium-shadow">
          <p class="text-xs uppercase opacity-60">
            Brand Plan
          </p>
          <h4 class="text-2xl font-bold mt-2">
            {{ plan.name }}
          </h4>
          <p class="text-xs opacity-60 mt-1">
            Renewal {{ plan.renewal }}
          </p>
        </div> -->

        <!-- ACCESS -->
        <div class="bg-white p-8 rounded-[2rem] premium-shadow border border-slate-50">
          <h3 class="text-xl font-bold mb-6">
            Account Access
          </h3>

          <div class="space-y-4">
            <p class="text-sm text-slate-400">
              This account has full access to discovery and insights.
            </p>

            <button
              @click="deacNow()"
              class="w-full border border-red-200 text-red-600
                     py-3 rounded-xl text-xs font-bold uppercase tracking-wider
                     hover:bg-red-50 transition"
            >
              Deactivate Account
            </button>
          </div>
        </div>
        <div class="bg-white p-8 rounded-[2.5rem] premium-shadow border border-slate-50">
          <h3 class="text-xl font-bold mb-6">
            Security
          </h3>

          <div class="space-y-6">
            <!-- <div class="toggle-row">
              <div>
                <strong>Two-Factor Authentication</strong>
                <p class="muted">
                  Require OTP verification on login
                </p>
              </div>
              <input type="checkbox" v-model="security.twoFactor" />
            </div> -->

            <div class="toggle-row">
              <div>
                <strong>Password</strong>
                <p class="muted">
                  Last updated {{ security.passwordUpdated }}
                </p>
              </div>
              <button @click="chPassNow()" class="link">Change</button>
            </div>
          </div>
        </div>

      </div>

    </section>

    <!-- CHANGE PASSWORD MODAL -->
<div v-if="showPasswordModal" class="modal-overlay">
  <div class="modal-card">

    <h3 class="text-xl font-bold mb-6">
      Change Password
    </h3>

    <div class="space-y-4">
      <div>
        <label class="label">Current Password</label>
        <input type="password" v-model="password.current" class="input" />
      </div>

      <div>
        <label class="label">New Password</label>
        <input type="password" v-model="password.new" class="input" />
      </div>

      <div>
        <label class="label">Confirm Password</label>
        <input type="password" v-model="password.confirm" class="input" />
      </div>
    </div>

    <div class="flex justify-end gap-4 mt-8">
      <button @click="showPasswordModal=false" class="dialog-btn muted">
        Cancel
      </button>

      <button @click="changePassword" class="dialog-btn primary">
        Update Password
      </button>
    </div>

  </div>
</div>


<!-- DEACTIVATE CONFIRMATION -->
<div v-if="showDeactivateDialog" class="modal-overlay">
  <div class="modal-card">

    <h3 class="text-xl font-bold">
      Deactivate Account
    </h3>

    <p class="text-sm text-slate-400 mt-2">
      This action will disable your brand account access.
      You can reactivate later via support.
    </p>

    <div class="flex justify-end gap-4 mt-8">
      <button @click="showDeactivateDialog=false" class="dialog-btn muted">
        Cancel
      </button>

      <button @click="deactivateAccount" class="dialog-btn danger">
        Yes, Deactivate
      </button>
    </div>

  </div>
</div>

  </section>
</template>
<script>
import { useToast } from "vue-toastification";

import {
  loadAgencySettingsApi,
  saveAgencySettingsApi
} from "../apis/agencysettingsapis";
import { changePasswordApi, deactivateAccountApi } from "@/apis/authapis";


export default {
  name: "AgencySettings",
  toast:null,
  data() {
    return {
      user_id: "",
      toast:null,
      showPasswordModal: false,
      showDeactivateDialog: false,
      profile: {
        name: "",
        email: "",
        website: "",
        industry: ""
      },
      password: {
        current: "",
        new: "",
        confirm: ""
      },
      privacy: {
        aggregated: false,
        export: false
      },

      security: {
        twoFactor: false,
        passwordUpdated: "-"
      },

      plan: {
        name: "No Active Plan",
        renewal: "-"
      }
    };
  },

  async mounted() {
    this.toast = useToast();
    try {
      const ldataRaw = sessionStorage.getItem("ldata");

      if (ldataRaw && ldataRaw !== "undefined") {
        const ldata = JSON.parse(ldataRaw);

        if (ldata && ldata.user_id) {
          this.user_id = ldata.user_id;
          this.profile.email = ldata.user_email || "";
          this.profile.name = ldata.user_name || "";
        }
      }
    } catch (e) {
      console.log("Session parse error", e);
    }

    await this.loadSettings();
  },

  methods: {
    deacNow(){
      this.showDeactivateDialog = true;
    },
    chPassNow(){
      this.showPasswordModal = true;
    },
    /* ✅ LOAD SETTINGS */
    async loadSettings() {

      const res = await loadAgencySettingsApi(this.user_id);

      if (res.status) {

        const settings = res.settings || {};
        const profile = res.profile || {};

        /* Profile */
        // this.profile.name = profile.agency_name || "";
        this.profile.website = profile.agency_website || "";
        this.profile.industry = profile.agency_company || "";

        /* Privacy */
        this.privacy.aggregated = settings.agset_auto_shortlist === "yes";
        this.privacy.export = settings.agset_show_pricing_estimates === "yes";

        /* Security */
        this.security.twoFactor = settings.agset_2fa_enabled === "yes";
        this.security.passwordUpdated = settings.password_updated || "-";

        /* Plan */
        this.plan = res.plan || {
          name: "No Active Plan",
          renewal: "-"
        };

      } else {

        this.toast.error("Failed to load settings");
      }
    },

    /* ✅ SAVE SETTINGS */
    async save() {

      if (!this.profile.name.trim()) {

        this.toast.error("Brand name required");
        return;
      }

      const payload = {

        agset_user: this.user_id,
        agset_company_name: this.profile.name,
        agset_company_logo: this.profile.website,
        agset_default_category: this.profile.industry,
        agency_email: this.profile.email,
        agset_auto_shortlist: this.privacy.aggregated ? "yes" : "no",
        agset_show_pricing_estimates: this.privacy.export ? "yes" : "no",
        agset_2fa_enabled: this.security.twoFactor ? "yes" : "no",
        agset_updated_by: this.user_id
      };

      const res = await saveAgencySettingsApi(payload);

      if (res.status) {
        if(res.udt){
          sessionStorage.setItem("ldata",JSON.stringify(res.udt));
          window.location.reload();
        }
        this.toast.success("Settings saved");

      } else {

        this.toast.error(res.success || "Save failed");
      }
    },

    async changePassword() {

      if (!this.password.current || !this.password.new || !this.password.confirm) {
        this.toast.warning("All password fields required");
        return;
      }

      if (this.password.new !== this.password.confirm) {
        this.toast.warning("Passwords do not match");
        return;
      }

      if (this.password.new.length < 6) {
        this.toast.warning("Password must be at least 6 characters");
        return;
      }

      const res = await changePasswordApi({
        user_id: this.user_id,
        current_password: this.password.current,
        new_password: this.password.new
      });

      if (res.status) {

        this.toast.success(res.success || "Password updated");

        this.showPasswordModal = false;

        this.password = {
          current: "",
          new: "",
          confirm: ""
        };

      } else {

        this.toast.error(res.success || "Password update failed");
      }
    },


    async deactivateAccount() {

      const res = await deactivateAccountApi(this.user_id);

      if (res.status) {

        this.toast.success(res.success || "Account deactivated");

        this.showDeactivateDialog = false;

        // Optional redirect after deactivate
        window.location.href = "/login";

      } else {

        this.toast.error(res.success || "Deactivation failed");
      }
    }

  }
};
</script>


<style scoped>
.label {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #94a3b8;
}

.input {
  width: 100%;
  margin-top: 6px;
  padding: 14px 16px;
  border-radius: 1rem;
  background: #f8fafc;
  font-weight: 600;
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.muted {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 2px;
}

.link {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

/* ===================================
   Brand SETTINGS – MOBILE PATCH
   =================================== */
@media (max-width: 640px) {

  /* Global padding override (px-12 / py-12) */
  .px-12 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .py-12 {
    padding-top: 24px !important;
    padding-bottom: 32px !important;
  }

  /* Header */
  header h2 {
    font-size: 26px !important;
    line-height: 1.2;
  }

  header p {
    font-size: 14px;
  }

  /* Main grid spacing */
  .gap-12 {
    gap: 24px !important;
  }

  /* Card normalization */
  .rounded-\\[2\\.5rem\\],
  .rounded-\\[2rem\\] {
    padding: 20px !important;
    border-radius: 20px !important;
  }

  /* Form grid */
  .md\\:grid-cols-2 {
    grid-template-columns: 1fr !important;
  }

  /* Inputs */
  .input {
    padding: 12px 14px;
    font-size: 14px;
  }

  /* Toggle rows */
  .toggle-row {
    gap: 12px;
    align-items: flex-start;
  }

  .toggle-row strong {
    font-size: 14px;
  }

  .muted {
    font-size: 12px;
  }

  /* Plan card */
  .bg-primary.p-8 {
    padding: 20px !important;
  }

  .bg-primary h4 {
    font-size: 20px;
  }

  /* Deactivate button */
  .border-red-200 {
    font-size: 11px;
    padding: 12px !important;
  }

  /* Save button */
  .flex.justify-end {
    justify-content: center !important;
  }

  .px-12.py-4 {
    width: 100%;
    padding: 14px 16px !important;
    font-size: 11px;
  }
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-card {
  width: 420px;
  max-width: 95%;
  background: white;
  padding: 32px;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.12);
}

.dialog-btn {
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
}

.dialog-btn.primary {
  background: #0f172a;
  color: white;
}

.dialog-btn.danger {
  background: #ef4444;
  color: white;
}

.dialog-btn.muted {
  background: #f1f5f9;
  color: #64748b;
}

</style>
